export default "/num1.png";